import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemCatalogGroupModel } from 'src/app/views/models/menu-item-catalog-group.model';

@Pipe({
  name: 'categoryFinder'
})
export class CategoryFinderPipe implements PipeTransform {

  transform(value: number, groups: MenuItemCatalogGroupModel[]): MenuItemCatalogGroupModel {
    return groups.find(x => x.id === value);
  }

}
